module.exports = __webpack_public_path__ + "img/certificate.f2a48546.svg";